import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { TrustBadges } from './TrustBadges';
import { GuaranteeBox } from './GuaranteeBox';
import { useOfferTimer } from '../hooks/useOfferTimer';
export function HeroSection() {
  const {
    isExpired,
    isInitialized
  } = useOfferTimer();
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-[#0a0a0a]" data-id="element-156">
      {/* Background texture overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `radial-gradient(ellipse at 20% 50%, #C0392B22 0%, transparent 60%),
                            radial-gradient(ellipse at 80% 50%, #1A527622 0%, transparent 60%)`
    }} data-id="element-157" />

      {/* Subtle grain texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`
    }} data-id="element-158" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 pt-10 pb-20 md:py-20 grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center" data-id="element-159">
        {/* Left: Text */}
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.9,
        ease: 'easeOut'
      }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-160">
          {/* Flag bar */}
          <motion.div initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flag-gradient h-1 w-24 mb-8 mx-auto lg:mx-0 origin-left" data-id="element-161" />

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-4 font-['Lato']" data-id="element-162">
            El libro que sacude conciencias
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="text-5xl md:text-6xl lg:text-7xl font-black leading-[1.05] mb-6 text-[#F5F0E8]" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-163">
            VENEZUELA
          </motion.h1>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.8
        }} className="text-2xl md:text-3xl lg:text-4xl font-bold leading-tight mb-8 text-[#E8D5B0]" style={{
          fontFamily: 'Playfair Display, serif',
          fontStyle: 'italic'
        }} data-id="element-164">
            La verdad que el mundo
            <br data-id="element-165" />
            <span className="text-[#CF9B2E]" data-id="element-166">no quiso ver.</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.7
        }} className="text-[#9A9080] text-lg md:text-xl leading-relaxed mb-4 max-w-lg mx-auto lg:mx-0" data-id="element-167">
            Únete a los miles de personas en todo el mundo que han decidido
            romper el silencio y descubrir la verdad que los medios ocultaron.
          </motion.p>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="text-[#E8D5B0] text-base md:text-lg leading-relaxed mb-10 max-w-lg mx-auto lg:mx-0" style={{
          fontFamily: 'Playfair Display, serif',
          fontStyle: 'italic'
        }} data-id="element-168">
            Un documento imprescindible para entender cómo se destruye una
            nación desde adentro y la crónica de la justicia que el mundo no
            quiso ver.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.85
        }} className="flex flex-col items-center lg:items-start gap-2 md:gap-4" data-id="element-169">
            <a href="https://templeofpages.com/es/cart/48590206533875:1" className="btn-primary inline-block w-full max-w-md px-10 py-6 text-base md:text-lg rounded-sm font-black tracking-wider text-center" aria-label={isExpired ? 'Comprar el libro por 27.99 USD' : 'Comprar el libro por 13.99 USD'} onClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart', {
                content_name: 'Venezuela — La verdad que el mundo no quiso ver',
                content_type: 'product',
                value: isExpired ? 27.99 : 13.99,
                currency: 'USD'
              });
            }
          }} data-id="element-170">
              {'ADQUIRIR CON 50% DE DESCUENTO \u2014 13.99 USD'}
            </a>

            <TrustBadges data-id="element-171" />

            <div className="w-full mt-3 flex justify-center lg:justify-start" data-id="element-172">
              <GuaranteeBox data-id="element-173" />
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-1 mt-2.5 w-full" data-id="element-174">
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-175" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-176" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-177" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-178" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-179" />
              <span className="text-[#9A9080] text-sm ml-2" data-id="element-180">
                4.9/5 basado en +8,600 lectores
              </span>
            </div>
          </motion.div>
        </motion.div>

        {/* Right: Book Cover */}
        <motion.div initial={{
        opacity: 0,
        x: 40,
        rotateY: -15
      }} animate={{
        opacity: 1,
        x: 0,
        rotateY: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="flex justify-center order-1 lg:order-2" style={{
        perspective: '1000px'
      }} data-id="element-181">
          <div className="relative" data-id="element-182">
            {/* Glow effect behind book */}
            <div className="absolute inset-0 blur-3xl opacity-30 bg-gradient-to-br from-[#C0392B] via-[#CF9B2E] to-[#1A5276] scale-110 rounded-lg" data-id="element-183" />

            <motion.img src="https://cdn.magicpatterns.com/uploads/9LpcEy5LEuRSi5KzDaMBHb/Portada_definitiva.png" alt="Portada del libro Venezuela — La verdad que el mundo no quiso ver" className="relative z-10 w-64 md:w-80 lg:w-96 shadow-2xl rounded-sm" style={{
            boxShadow: '0 25px 60px rgba(0,0,0,0.8), -8px 8px 30px rgba(207,155,46,0.2)'
          }} whileHover={{
            scale: 1.03,
            rotateY: 5
          }} transition={{
            duration: 0.4
          }} data-id="element-184" />
          </div>
        </motion.div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0a0a0a] to-transparent pointer-events-none" data-id="element-185" />

      {/* Mobile-only scroll indicator — pulsating amber chevron */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: [0.4, 1, 0.4],
      y: [0, 5, 0]
    }} transition={{
      delay: 1.2,
      duration: 1.8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="md:hidden absolute bottom-5 left-1/2 -translate-x-1/2 z-20 pointer-events-none" aria-hidden="true" data-id="element-186">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#CF9B2E" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-187">
          <polyline points="6 9 12 15 18 9" data-id="element-188" />
        </svg>
      </motion.div>
    </section>;
}